import { render, staticRenderFns } from "./topSales.vue?vue&type=template&id=d47689b6&"
import script from "./topSales.vue?vue&type=script&lang=js&"
export * from "./topSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports